export default "__VITE_ASSET__zsllcJhN__"